<template>
     <v-row>
    <v-col cols="12">
      <v-container>
        <v-card>
          <v-card-actions>
            <v-select v-model="size" :items="items" label="Size"></v-select>
            <div class="flex-grow-1"></div>
          </v-card-actions>
        </v-card>
      </v-container>
    </v-col>
    <v-col cols="12">
      <v-container v-bind="{ [`grid-list-${size}`]: true }" fluid>
        <v-row>
          <v-col cols="12" md="4">
            <v-card
              color="primary"
              link
              @click.stop="openDialog = !openDialog"
              style="height:200px"
              dark
              class="animated zoomIn"
            >
              <v-card-title>Neue Präsentatoni ersteonnen</v-card-title>
              <v-card-text>aerlasödkfj</v-card-text>
            </v-card>
          </v-col>

          <v-col v-for="(item, i) in presentations" :key="item.id" cols="12" md="4" class="animated zoomIn">
            <v-card :to="'/editor/' + $route.params.eventid + '/slide/' + item.id">
              <v-card-title>slide {{item.title}} {{i}} {{new Date().getTime()}}</v-card-title>
              <v-img
                :src="`https://unsplash.it/150/300?image=${Math.floor(Math.random() * 100) + 1}`"
                height="200px"
              ></v-img> 
              <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn text color="blue" @click="remove(item.id)">Delete</v-btn>
              </v-card-actions>
            </v-card>
          </v-col>
        </v-row>
        <CreateDialog v-model="openDialog"></CreateDialog>
      </v-container>
    </v-col>
  </v-row>
</template>
<script>
import { mapState, mapActions } from "vuex";
import CreateDialog from "@/components/event/CreateDialog";

export default {
  components: {
    CreateDialog
  },
  data: () => ({
    size: "sm",
    openDialog: false,
    items: [
      { text: "Extra small (2px)", value: "xs" },
      { text: "Small (4px)", value: "sm" },
      { text: "Medium (8px)", value: "md" },
      { text: "Large (16px)", value: "lg" },
      { text: "Extra large (24px)", value: "xl" }
    ]
  }),

  methods: {
    ...mapActions("slides", ["insert", "set", "delete", "fetchById"]),
    remove(id) {
        this.delete(id);
    }
  },
  computed: {
    presentations() {
      const pageId = this.$route.params.eventid;
        console.log(pageId);
      let result =  Object.values(this.$store.state.slides.data).filter(
        item => {
            console.log("filtering stada");
            console.log(item);
            console.log("this is an event???");
            return item.event === pageId
//return true;
            }
      );
      //console.log(result);
      return result;
    }
  }
};
</script>